import { restClient } from '@/Core'

/** Скасувати сесію: бек звільняє резерв квоти й видаляє шматки — `DELETE /services/disk/uploads/{uuid}`. */
export const CancelDiskUploadTask = async (uuid: string): Promise<void> => {
    await restClient.delete(`/services/disk/uploads/${encodeURIComponent(uuid)}`)
}
